import CartBaseItemView from '../../baseViews/ItemView';
import OverviewWarningMessagesViewTemplate from '../templates/OverviewWarningMessagesViewTemplate';

const OverviewWarningMessagesView = CartBaseItemView.extend({
	JSXTemplate: OverviewWarningMessagesViewTemplate,
	initialize () {

		this.listenTo(this.model, 'change:displayableWarnings', this.render);

	},
	templateHelpers () {

		const helpers = {
			warnings: _.pluck(
				this.model.get('displayableWarnings'),
				window.lp.globals.isCustomerService ? 'Message' : 'UserFriendlyMessage'
			)
		};

		return helpers;

	}
});

export default OverviewWarningMessagesView;
